var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-sheet',{attrs:{"color":"orange lighten-2"}},[_vm._v("Hello, world! I'm a simple v-sheet")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }